import React, { useState, useEffect } from "react";
import PaymentForm from "./Payments Modals/PaymentForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import StatComponent from "../../stat-page/StatComponent";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddPaymentForm from "./Payments Modals/AddPaymentForm";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Repayments from "./Payments Modals/RepaymentForm";
import HistoryIcon from "@material-ui/icons/History";
import { LOAD_PAYMENT_HISTORY } from "../../../../redux-store/reducers/actions/Constants";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "paymentType", label: "Cash Recieved" },
  { id: "paymentType", label: "Account Type" },
  { id: "categoryName", label: "Payment Type" },
  { id: "customerName", label: "Customer Name" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Payment({
  payments,
  UpdatePayment,
  DeletePayment,
  LoadPayments,
  companyId,
  AddPayment,
  categories,
  accounts,
  accountTypes,
  paymentTypes,
  cardTypes,
  LoadPaymenthistory,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [repayPopup, setRepayPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });


  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(payments, headCells, filterFn);

  useEffect(() => {
    LoadPayments(companyId);
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.PaymentName.toLowerCase().includes(target.value),
          );
      },
    });
  };

  const addOrEdit = (payment, resetForm) => {
    var data = { ...payment, companyId: companyId };
    UpdatePayment(data);
    resetForm();
    // setRecordForEdit(null)
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addPayment = (payment, resetForm) => {
    var data = { ...payment, companyId: companyId };
    AddPayment(data);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    DeletePayment(id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  console.log("Here are your Payments 💸", payments);
  return (
    <div>
      <Column>
        <ToastContainer />
       { /*<div className="pr-2">
          <Controls.Input
            placeholder="Search Payments by Payment Name"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
          />
          </div>*/}
        <Paper className={classes.pageContent}>
          <h4>
            {" "}
            <strong>Payments</strong>
          </h4>
          <div style={{ position: "relative", left: "51rem" }}></div>
          <TblContainer>
            <TblHead />
            <TableBody>
              {recordsAfterPagingAndSorting().map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.amountToPay}</TableCell>
                  <TableCell>{item.accountTypeName}</TableCell>
                  <TableCell>{item.paymentTypeName}</TableCell>
                  <TableCell>{item.customerName}</TableCell>
                  <TableCell>
                    <Controls.ActionButton
                      color="primary"
                      onClick={() => {
                        openInPopup(item);
                      }}
                    >
                      <EditOutlinedIcon fontSize="small" />
                    </Controls.ActionButton>

                  
                    {/* Products-History */}
                    <Link to="/payment/history">
                      <Controls.ActionButton
                        color="primary"
                        onClick={() => LoadPaymenthistory(item.transactionReference)}
                      >
                        <HistoryIcon fontSize="small" />
                      </Controls.ActionButton>
                    </Link>
                    {/* End Products History */}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </Paper>

        <Popup
          title="Repayment Form"
          openPopup={openPopup}
          setOpenPopup={setRepayPopup}
        >
          <Repayments setOpenPopup={setOpenPopup} />
        </Popup>

        <Popup
          title="Payment Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PaymentForm
            recordForEdit={recordForEdit}
            addOrEdit={addOrEdit}
            categories={categories}
            accounts={accounts}
            accountTypes={accountTypes}
            paymentTypes={paymentTypes}
            cardTypes={cardTypes}
          />
        </Popup>

        <Popup
          title="Add Payment Form"
          openPopup={addOpenPopup}
          setOpenPopup={setAddOpenPopup}
        >
          <AddPaymentForm
            recordForEdit={recordForEdit}
            addOrEdit={addPayment}
            categories={categories}
           
  
            accounts={accounts}
            accountTypes={accountTypes}
            paymentTypes={paymentTypes}
            cardTypes={cardTypes}
          />
        </Popup>
        <Notification notify={notify} setNotify={setNotify} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Column>
    </div>
  );
}

function mapStateToProps(state) {
  console.log(state.salesReducer.payments)
  return {
    buttonloader: state.utilityReducer.buttonloader,
    payments: state.salesReducer.payments,
    accountTypes: state.salesReducer.accountTypes,
    accounts: state.salesReducer.accounts,
    paymentTypes: state.salesReducer.paymentTypes,
    cardTypes: state.salesReducer.cardTypes,
  };
}
const mapDispatchToProps = (dispatch) => ({
  AddPayment(payload) {
    dispatch({ type: "ADD_PAYMENT", payload });
  },

  LoadPayments(payload) {
    dispatch({ type: "LOAD_PAYMENT", payload });
  },
  LoadPaymenthistory(payload) {
    dispatch({ type: LOAD_PAYMENT_HISTORY, payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
